import axios from 'axios'
import type { chipset, addchipset,pagination } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'chipset'

export const readChipsetListAPI = async (pagination: pagination): Promise<chipset[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ...pagination
    }
  })
  console.log("readChipsetListAPI 응답:", response.data)
  return response.data.data
}

export const addChipsetAPI = async (addChipset: addchipset): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
      ...addChipset
    }
  })
  console.log("addChipsetAPI 응답:", response.data)
  return response.data
}

export const updateChipsetAPI = async (chipset: chipset): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...chipset
    }
  })
  console.log("updateChipsetAPI 응답:", response.data)
  return response.data
}

export const deleteChipsetAPI = async (id: number): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id,
    }
  })
  console.log("deleteChipsetAPI 응답:", response.data)
  return response.data
}

export const paginationChipsetAPI = async (size: number): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      size: size,
    }
  })
  console.log("paginationChipsetAPI 응답:", response.data)
  return response.data.data.totalpage
}